<template>
    <div>

        <rkm-area
            title="Identificação do veículo"
            type="section"
            no-margin-top
        >
            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-input
                        label="Placa"
                        v-model="form.veiculo.numeroPlaca"
                        type="text"
                        uppercase
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        label="Marca"
                        v-model="form.veiculo.descricaoMarca"
                        type="text"
                        uppercase
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        label="Modelo"
                        v-model="form.veiculo.descricaoModelo"
                        type="text"
                        uppercase
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        label="Tipo de veículo"
                        v-model="form.veiculo.descricaoTipo"
                        type="text"
                        upperase
                        disabled
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-input
                        label="Tipo de passageiro"
                        v-model="form.veiculo.passageiroDescricaoTipo"
                        type="text"
                        uppercase
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        label="Capacidade"
                        v-model="form.veiculo.numeroCapacidade"
                        type="text"
                        uppercase
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        label="Ano de fabricação"
                        v-model="form.veiculo.anoFabricacao"
                        type="text"
                        uppercase
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        label="Cor predominante"
                        v-model="form.veiculo.descricaoCor"
                        type="text"
                        uppercase
                        disabled
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-form
            ref="Form"
        >
            <rkm-area
                type="section"
                title="Inclusão de nova jornada"
                no-margin-top
            >

                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-row class="flex-nowrap">
                            <rkm-col cols="6">
                                <rkm-row>

                                    <rkm-col cols="4">
                                        <rkm-form-select
                                            :options="form.tipoJornada"
                                            label="Tipo de Jornada"
                                            show-default-option
                                            default-option-text="Múltiplas"
                                            text-field="text"
                                            v-model="jornada.tipoId"
                                            value-field="value"
                                            :disabled="this.index != null ? true : false"
                                        />
                                    </rkm-col>

                                    <rkm-col class="flex-grow-1">
                                        <rkm-form-date-picker
                                            ref="periodo"
                                            range
                                            :range-inline="false"
                                            start-label="Período de"
                                            end-label="Até"
                                            v-model="jornada.periodo"
                                            :start-validations="validations.periodo.start"
                                            :end-validations="validations.periodo.end"
                                            :disabled="this.index != null ? true : false"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row v-if="!jornada.tipoId">

                                    <rkm-col cols="12">
                                        <rkm-form-checkbox-group
                                            label="Dias da semana"
                                            v-model="jornada.diasSemana"
                                            :options="form.diasSemana"
                                            text-field="descricao"
                                            value-field="id"
                                            buttons
                                            button-color="outline-primary"
                                            :validations="validations.diasSemana"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row>

                                    <rkm-col class="flex-grow-1">
                                        <rkm-form-time-picker
                                            ref="horaInicial"
                                            label="Horário Inicial"
                                            v-model="jornada.horaInicial"
                                            :validations="validations.horaInicial"
                                        />
                                    </rkm-col>

                                    <rkm-col class="flex-grow-1">
                                        <rkm-form-time-picker
                                            ref="horaFim"
                                            label="Horário Final"
                                            v-model="jornada.horaFim"
                                            :disabled="!jornada.horaInicial"
                                            :validations="validations.horaFim"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row>

                                    <rkm-col class="flex-grow-1">
                                        <rkm-button
                                            @click.stop="add"
                                            color="primary"
                                        >
                                            {{ index !== null ? 'Alterar Jornada' : 'Incluir jornada' }}
                                        </rkm-button>

                                        <rkm-button
                                            @click="cancelForm"
                                            color="primary"
                                        >
                                            {{ index == null ? 'Limpar' : 'Voltar' }}
                                        </rkm-button>
                                    </rkm-col>
                                </rkm-row>

                            </rkm-col>
                            <rkm-col class="flex-grow-1">

                                <rkm-calendar
                                    :items="diasCalendario"
                                    @click="openModal"
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-form>

        <Modal
            ref="Modal"
            :model="model"
            :form="form"
        />
    </div>
</template>

<script>

// Mixins.
import { error, repository, stringCase, object, data, calculations } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

// Components.
import Modal from '@/components/transporte-paciente/jornada/components/cadastro/Modal'

// Moment.
import moment from 'moment'

export default {
    components: { Modal },
    computed:{
        validations() {
            return {
                periodo: {
                    start: { required: true },
                    end: { required: true },
                },
                diasSemana: { required: true },
                horaInicial: { required: true },
                horaFim: {
                    required: true,
                    min_hour: this.handleMinHour()
                },

            }
        },
    },
    created() {
        this.repositories = {
            jornada: this.getConectaSusRepository('transportePaciente.jornada'),
            feriado: this.getConectaSusRepository('cadastro.feriado.feriado')
        }
    },
    data: () => ({
        isReadOnly: false,
        dateFormatUs: 'YYYY-MM-DD',
        dateFormatBr: 'DD/MM/YYYY',
        dateTimeFormatUs: 'YYYY-MM-DD HH:mm:ss',
        dateTimeFormatBr: 'DD/MM/YYYY HH:mm:ss',
        dataAtual: '',
        tabIndex: 1,
        checkData: '',
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        add() {

            this.validate()
                .then(valid => {

                    if (!valid) return

                    const { start, end } = this.jornada.periodo;

                    const inicio = moment(start, this.dateFormatUs);
                    const fim = moment(end, this.dateFormatUs);

                    const ForDataInicio = inicio.toDate();
                    const ForDataFinal = fim.toDate();

                    let msg = ''

                    if (!this.jornada.tipoId) {

                        for (let dataInserida = new Date(ForDataInicio);
                            dataInserida <= ForDataFinal;
                            dataInserida.setDate(dataInserida.getDate() + 1)) {

                            const jornada = this.clone(this.jornada)

                            jornada.horaInicial = this.jornada.horaInicial.substr(0, 5)
                            jornada.horaFim = this.jornada.horaFim.substr(0, 5)

                            jornada.data = this.getFormatedDate(dataInserida, this.dateFormatBr)

                            jornada.diasSemana.forEach((diaSemana) => {

                                var data = moment(jornada.data, this.dateFormatBr).toDate()
                                var dia = data.getDay() + 1;

                                if (dia === diaSemana){

                                    jornada.semanaId = dia

                                    const trataJornada = this.handleJornada(dataInserida, dataInserida, msg);

                                    jornada.dataInicial = trataJornada.dataInicial,
                                    jornada.dataFinal = trataJornada.dataFinal
                                    jornada.geralDiaSemanaId = trataJornada.geralDiaSemanaId
                                    jornada.geralDiaSemanaDescricao = trataJornada.geralDiaSemanaDescricao

                                    if (trataJornada.existeJornada) {

                                        msg = trataJornada.msg

                                        this.mensagemConflito(msg);
                                        return;
                                    }

                                    const msgFeriados = this.checkFeriados(jornada, msg);

                                    if (msgFeriados) {

                                        msg = msgFeriados

                                        this.mensagemConflito(msg);
                                        return;
                                    }

                                    if( this.index == null ){

                                        jornada.id = this.uniqueId('jornada' + new Date().getTime())
                                        this.model.jornadas.push(jornada)

                                    } else {

                                        const objIndex = this.model.jornadas.findIndex((obj => obj.id == jornada.id));

                                        this.$set(this.model.jornadas, objIndex, this.clone(jornada))
                                    }

                                    if (msg === '') {

                                        this.jornadas = this.model.jornadas
                                    }

                                    this.sucessAdd()
                                    this.$nextTick(() => this.mensagemConflito(msg))
                                    this.cancelForm()
                                }
                            })
                        }
                    } else {

                        const jornada = this.clone(this.jornada)

                        jornada.horaInicial = this.jornada.horaInicial.substr(0, 5)
                        jornada.horaFim = this.jornada.horaFim.substr(0, 5)

                        const trataJornada = this.handleJornada(start, end, msg);

                        jornada.dataInicial = trataJornada.dataInicial,
                        jornada.dataFinal = trataJornada.dataFinal
                        jornada.geralDiaSemanaId = trataJornada.geralDiaSemanaId
                        jornada.geralDiaSemanaDescricao = trataJornada.geralDiaSemanaDescricao

                        if (trataJornada.existeJornada) {

                            msg = trataJornada.msg

                            this.mensagemConflito(msg);
                            return;
                        }

                        const msgFeriados = this.checkFeriados(jornada, msg);

                        if (msgFeriados) {

                            msg = msgFeriados

                            this.mensagemConflito(msg);
                            return;
                        }

                        if( this.index == null ){

                            jornada.id = this.uniqueId('jornada' + new Date().getTime())
                            this.model.jornadas.push(jornada)

                        } else {

                            const objIndex = this.model.jornadas.findIndex((obj => obj.id == jornada.id));

                            this.$set(this.model.jornadas, objIndex, this.clone(jornada))
                        }

                        if (msg === '') {

                            this.jornadas = this.model.jornadas
                        }

                        this.sucessAdd()
                        this.$nextTick(() => this.mensagemConflito(msg))
                        this.cancelForm()
                    }

                    this.$refs.Form.resetValidator()
                })
        },
        handleJornada(DataInicio, DataFim, msg) {

            const existeJornada = this.checkJornada(DataInicio, DataFim);

            const dataInicial = moment(
                this.getFormatedDate(DataInicio, this.dateFormatBr).concat(' ', this.jornada.horaInicial),
                this.dateTimeFormatBr
            ).format(this.dateTimeFormatUs);

            const dataFinal = moment(
                this.getFormatedDate(DataFim, this.dateFormatBr).concat(' ', this.jornada.horaFim),
                this.dateTimeFormatBr
            ).format(this.dateTimeFormatUs);

            const geralDiaSemanaId = moment(DataInicio).day() + 1;
            const geralDiaSemanaDescricao = this.form.diasSemana.find(d => d.id == geralDiaSemanaId).descricao;

            if(existeJornada){
                const inicio = moment(dataInicial).format('DD/MM/YYYY HH:mm')
                const fim = moment(dataFinal).format('DD/MM/YYYY HH:mm')

                msg = msg.concat('<br/>', geralDiaSemanaDescricao, ' - ', inicio, ' - ', fim, ' - Conflito de horário.')
            }

            return {
                msg: msg,
                dataInicial: dataInicial,
                dataFinal: dataFinal,
                geralDiaSemanaId: geralDiaSemanaId,
                geralDiaSemanaDescricao: geralDiaSemanaDescricao,
                existeJornada: existeJornada,
            }
        },
        checkFeriados(jornada, msg) {

            const inicio = moment(jornada.dataInicial).format('DD/MM/YYYY')
            const fim = moment(jornada.dataFinal).format('DD/MM/YYYY')

            const feriados = this.form.feriados.filter((j) => {
                return j.data >= inicio && j.data <= fim;
            });

            if (feriados.length > 0) {

                feriados.forEach((feriado) => {

                    msg += `<br/> ${this.form.diasSemana[moment(feriado.data, this.dateFormatBr).day()].descricao}
                        - ${feriado.data} - Feriado e/ou ponto facultativo.`;
                });

                return msg;
            }
        },
        checkJornada(DataInicio, DataFim) {

            const index = this.model.jornadas.findIndex((obj => obj.id == this.jornada.id));

            return this.model.jornadas.find((j, i) => {

                const dataInicial = moment(DataInicio, this.dateFormatBr).format(this.dateFormatUs)
                const dataFinal = moment(DataFim, this.dateFormatBr).format(this.dateFormatUs)

                const horaInicial = moment(dataInicial.concat(' ', this.jornada.horaInicial), this.dateTimeFormatUs)
                const horaFinal = moment(dataFinal.concat(' ', this.jornada.horaFim), this.dateTimeFormatUs)

                return index !== i && moment(horaInicial).isBetween(
                        moment(j.dataInicial, this.dateTimeFormatUs),
                        moment(j.dataFinal, this.dateTimeFormatUs)
                    )
                    || index !== i && moment(horaFinal).isBetween(
                            moment(j.dataInicial, this.dateTimeFormatUs),
                            moment(j.dataFinal, this.dateTimeFormatUs)
                        )
                    || index !== i && moment(horaInicial).isSame(
                            moment(j.dataInicial, this.dateTimeFormatUs)
                        )
                    || index !== i && moment(horaFinal).isSame(
                            moment(j.dataFinal, this.dateTimeFormatUs)
                        )
                    || index !== i
                        && moment(
                            this.getFormatedDate(horaInicial, this.dateTimeFormatUs)
                        )
                            .isBefore(
                                j.dataInicial,
                            )
                        && moment(this.getFormatedDate(horaFinal, this.dateTimeFormatUs))
                            .isAfter(
                                j.dataFinal,
                            )
            })
        },
        openModal(item){

            const diaTratado = moment(item.date).format(this.dateFormatUs)
            const dataTratada = moment(item.date).format(this.dateFormatBr)

            var data = moment(item.date, this.dateFormatBr).toDate()
            var semanaId = data.getDay() + 1;

            const diaSelecionado = this.model.jornadas.filter(
                dias => moment(dias.dataInicial).format(this.dateFormatUs) <= diaTratado
                    && moment(dias.dataFinal).format(this.dateFormatUs) >= diaTratado
            )

            if(diaSelecionado.length > 0){

                this.$refs.Modal.open(item, diaSelecionado, dataTratada, semanaId)
            }
        },
        mensagemConflito(msg){

            if(msg){

                if (this.jornada.tipoId == null) {

                    this.showAlert('Não foi possível cadastrar a jornada nas seguintes datas: '  + msg)
                } else {

                    this.showAlert('Não foi possível cadastrar a jornada: '  + msg)
                }
            }
        },
        cancelForm(){

            this.$emit('backTabs')

            this.disabledSemanas()
        },
        sucessAdd(){

            this.$emit('backTabsNotification')
        },
        validate() {

            return this.$refs.Form.validate()
        },
        disabledSemanas(){

            this.form.diasSemana.forEach(s => s.disabled = true)
        },
        resetForm(){

            this.jornada.horaInicial = ''
            this.jornada.horaFim = ''
            this.jornada.periodo.start = ''
            this.jornada.periodo.end = ''
        },
        save() {

            this.setLoading()

            const jornadas = this.prepareData()

            const request = this.repositories.jornada.store(jornadas)

            request
                .then(response => {
                    this.showSaveNotification()
                    this.$emit('save', response)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
            },
        prepareData() {

            const veiculoId = this.form.veiculo.id

            const jornadas = this.clone(this.jornadas).map(function(jornada) {

                return {
                    id: jornada.id ?? null,
                    veiculoId: veiculoId,
                    dataInicial: jornada.dataInicial,
                    dataFinal: jornada.dataFinal,
                    geralDiaSemanaId: jornada.geralDiaSemanaId,
                }
            })

            return this.camelObjectKeysToSnakeRecursive({
                veiculoId: veiculoId,
                jornadas: jornadas
            })
        },
        handleMinHour() {

            const horario = moment(this.jornada.horaInicial, 'HH:mm').add(1, 'minutes').format('HH:mm')
            const dataInicio = this.getFormatedDate(this.jornada.periodo.start, this.dateFormatUs)
            const dataFinal = this.getFormatedDate(this.jornada.periodo.end, this.dateFormatUs)

            return this.jornada.tipoId
                ? dataInicio === dataFinal ? horario : false
                : horario
        },
        handleDiasSemana() {

            this.disabledSemanas()

            const periodo = this.jornada.periodo

            if(periodo.start || periodo.end){

                let indices = []

                if(periodo.start){

                    let dataStart = moment(periodo.start, this.dateFormatUs).toDate()
                    const index = this.form.diasSemana.findIndex(d => d.id == dataStart.getDay() + 1)
                    indices.push(index)
                }

                if(periodo.end){

                    let dataEnd = moment(periodo.end, this.dateFormatUs).toDate()
                    const index = this.form.diasSemana.findIndex(d => d.id == dataEnd.getDay() + 1)
                    indices.push(index)
                }

                if(periodo.start && periodo.end){

                    indices = []

                    let dataStart = moment(periodo.start, this.dateFormatUs)
                    let dataEnd = moment(periodo.end, this.dateFormatUs)

                    let indice = 0

                    while (dataStart.isSameOrBefore(dataEnd) && indice < 7) {

                        const index = this.form.diasSemana.findIndex(d => d.id == dataStart.toDate().getDay() + 1)
                        indices.push(index)

                        dataStart.add(1, 'd')

                        indice++
                    }
                }

                indices.forEach(indice => {

                    this.form.diasSemana[indice].disabled = false
                })

                if(indices.length == 1) {
                    this.jornada.diasSemana = [moment(periodo.start).day() + 1]
                }
            }
        },
    },
    mounted(){

        this.$refs.Form.resetValidator()
    },
    mixins: [ error, repository, stringCase, object, data, calculations],
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
        jornada: { type: Object, required: true },
        jornadas: { type: Array, required: true },
        diasCalendario: { type: Array, required: true },
        index: { type: Number, default: null },
        id: { type: Number },
    },
    watch: {
        'model.jornadas': function () {

            let diasCalendario = []

            this.model.jornadas.forEach(jornada => {

                const dataInicial = moment(jornada.dataInicial, this.dateFormatUs).toDate();
                const dataFinal = moment(jornada.dataFinal, this.dateFormatUs).toDate();

                if (moment(dataInicial).isSame(dataFinal, 'day')) {

                    diasCalendario.push({
                        'dates': dataInicial,
                        'title': 'icon-search',
                        'highlight': 'green'
                    });
                } else {

                    for (let data = moment(dataInicial); data <= moment(dataFinal); data.add(1, 'day')) {
                        diasCalendario.push({
                            'dates': data.toDate(),
                            'title': 'icon-search',
                            'highlight': 'green'
                        });
                    }
                }
            });

            this.form.feriados.map(feriado =>

                diasCalendario.push({
                    'dates': moment(feriado.data, 'DD/MM/YYYY').toDate(),
                    'highlight': 'yellow',
                    'title': feriado.tipoNome,
                    'popover':  feriado.observacao
                })
            )

            this.$emit('loadDiasCalendario', diasCalendario)
        },
        'jornada.periodo': {
            deep: true,
            handler: function () {

                this.$nextTick().then(() => this.handleDiasSemana())
            }
        }
    }
}
</script>

<style scoped>
.calendario {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.calendario img {
    max-width: 100%;
    max-height: 100%;
    margin: 1rem 0;
}
.form-group-radio-button-disabled, .form-group-checkbox-button-disabled {
    width: 100%
}
</style>